import { ReactElement } from 'react';

import { ConfidentialAccessLevel } from '@dreryk/egabinet-personnel-frontend-api';

import { FormContextValues } from '@dreryk/react-common';
import { AutoLayout, Notification, NotificationSize, NotificationType } from '@dreryk/react-components';

import { useCurrentPractitionerGlobalState } from '~libs.shared.account';

import { medicalDocumentationCreateTranslationKeys } from '../../translations';

import { ConfidentialAnnotationCheckbox } from './ConfidentialAnnotationCheckbox';
import { MedicalDocumentationCreateFormBean } from './MedicalDocumentationCreateForm.types';

type ConfidentialDocumentationSectionProps = Pick<FormContextValues<MedicalDocumentationCreateFormBean>, 'register'>;

export const ConfidentialDocumentationSection = (props: ConfidentialDocumentationSectionProps): ReactElement | null => {
   const { getCurrentPractitioner } = useCurrentPractitionerGlobalState();
   const confidentialAccessLevel: ConfidentialAccessLevel | undefined = getCurrentPractitioner()
      ?.confidentialAccessLevel;

   if (!confidentialAccessLevel) {
      return null;
   }

   return (
      <AutoLayout as={'div'} $direction={'vertical'} $horizontalResizing={'fill'} $spacing={12}>
         <ConfidentialAnnotationCheckbox register={props.register} />
         {confidentialAccessLevel === 'AUTHORIZED' && (
            <Notification
               testId={'authorizedConfidentialWarning'}
               size={NotificationSize.SMALLER}
               type={NotificationType.WARNING}
               label={medicalDocumentationCreateTranslationKeys.authorizedConfidentialWarning}
            />
         )}
      </AutoLayout>
   );
};
